import React from 'react';
import InfoGrid from "../../../../../components/info-grid/info-grid.jsx";
import ObservationBox from "../../../../../components/observation-box/observation-box.jsx";
import AttachmentContent from "./attachment-content.jsx";
import ProjectUtils from "../../../../../utils/project-utils.js";

const BASENAME = import.meta.env.BASE_URL;

const formatEcap = (value) => {
    if (!value) return null;
    const [number, year] = String(value).split("/");
    return `${parseInt(number, 10)}-${year}`;
};

const ReportContent = ({ data, printOptions }) => {

    return (
        <>
            { data.map((element, index) => {
                const user = element.user_namewar ? `${element.user_name} (${element.user_namewar})` : element.user_name;
                const attaches = JSON.parse(element?.attaches?.value || "[]");

                return (
                    <div key={index} className="print:break-inside-avoid-page">
                        <div className={"pb-6"}>
                            <div className="text-center main-divisor-header text-[14px] font-bold !p-2">
                                <a href={`${BASENAME}ecap-solicitation/form/${element.id}`} target="_blank" className={'hover:text-[#1588F3]'}>
                                    Solicitação Nº {element.id}
                                </a>
                            </div>

                            <InfoGrid
                                columns={2}
                                className={'pb-1.5 pt-3'}
                                items={[
                                    {label: "D/H do fato", value: ProjectUtils.formatDate(element.incident_datetime), className: "font-bold !text-[#52525C]"},
                                    {label: "Solicitante", value: element.applicant, className: "font-bold !text-[#52525C]"},
                                ]}
                            />

                            <InfoGrid
                                columns={2}
                                className={'py-1.5'}
                                items={[
                                    {label: "Natureza", value: element.nature_name ?? "Não informado", className: "font-bold !text-[#52525C]"},
                                    {label: "Status", value: element.status ?? "Não informado", className: "font-bold !text-[#52525C]"}
                                ]}
                            />

                            <InfoGrid
                                columns={2}
                                className={'py-1.5'}
                                items={[
                                    {label: "ECAP", value: !element.ecap_id ? "Não vinculado" : undefined, className: "font-bold !text-[#52525C]",
                                        children: element.ecap_id ? (
                                            <a href={`${BASENAME}ecap/form/${formatEcap(element.ecap_id)}`} target="_blank" className="inner-link">
                                                {element.ecap_id}
                                            </a>
                                        ) : undefined,
                                    },
                                    {label: "Cadastrado por", value: user, className: "font-bold !text-[#52525C]"},
                                ]}
                            />

                            <div className="grid grid-cols-2 gap-4 px-5 pt-6">
                                <ObservationBox title="Descrição da solicitação" titleClassName={'!text-[#52525C] !left-2 !font-bold'} boxClassName={'!text-[14px]'}>
                                    {element.description ?? ""}
                                </ObservationBox>

                                <ObservationBox title="Observação do agente" titleClassName={'!text-[#52525C] !left-2 !font-bold'} boxClassName={'!text-[14px]'}>
                                    {element.user_observation ?? ""}
                                </ObservationBox>
                            </div>

                            {attaches.length > 0 && (
                                <AttachmentContent attaches={attaches} printOptions={printOptions}/>
                            )}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default ReportContent;